module.exports = __webpack_public_path__ + "img/hero04__1615360459_203.109.44.209.18f16c2b.jpg";